// 财务管理（结算记录）已关闭
// import Layout from '@/layout';
// const settlementRouter = {
//   path: '/settlement',
//   component: Layout,
//   redirect: '/settlement/list',
//   name: 'SupplierSettlement',
//   meta: { title: '财务管理', icon: 'el-icon-money' },
//   children: [
//     { path: 'list', component: () => import('@/views/supplier/settlement/index'), name: 'SupplierSettlementList', meta: { title: '结算记录' } },
//   ],
// };
// export default settlementRouter;